import { Pagination as BasePagination } from 'baseui/pagination'
import React from 'react'
import { getPaginationOverrides } from './helpers'

type PropsT = {
  currentPage: number
  onChangePage: (page: number) => void
  numPages: number
}

const Pagination: React.FC<PropsT> = ({
  currentPage,
  onChangePage,
  numPages,
}: PropsT) => {
  return (
    <BasePagination
      currentPage={currentPage}
      onPageChange={({ nextPage }) => onChangePage(Math.max(nextPage, 1))}
      numPages={numPages}
      overrides={getPaginationOverrides(currentPage, numPages, onChangePage)}
    />
  )
}

export default Pagination
